import BaseService from "@/boot/BaseService";
class PrecioListaService extends BaseService {
    constructor() {
        super(null, "/precio-lista");
    }
    async index() {
        return await this.get("/");
    }
    async getActiveListItems(filter, search, page, pageSize) {
        try {
            return await this.get("/items/active-list", {
                filter,
                search,
                page,
                pageSize,
            });
        } catch (error) {
            console.error(error);
        }
    }

    async getPaneles(filter, tipoPanel = null) {
        return await this.get("/items/paneles", {
            filter,
            tipoPanel,
        });
    }

    async getListaCamaraAccesorios(filter) {
        return await this.get("/items/camara/accesorios", {
            filter,
        });
    }

    async getPuertaAccesorios(filter) {
        return await this.get("/items/puerta/accesorios", {
            filter,
        });
    }

        async getPuertaList(filter) {
        return await this.get("/items/puerta", {
            filter,
        });
    }

    async getPuertaAccesorios(filter) {
        return await this.get("/items/puerta/accesorios", {
            filter,
        });
    }

    async getAll() {
        return await this.get("/all");
    }

    async getItemData(id) {
        return await this.get(`/items/datos/${id}`);
    }
}

export default new PrecioListaService();
